module.exports = __webpack_public_path__ + "static/media/telethon-logo-horizontal.b01e075f.svg";